module.exports = __webpack_public_path__ + "img/xbj-01.d719314b.svg";